import { action } from 'satcheljs';

/**
 * Updates the Event Body using the uiState
 */
export default action('setEventBodyFromViewState');
